import React from 'react';

const NotFound = () => {

	//TODO pending design / development
	return (
		<div>Not found!</div>
	);

}

export default NotFound;
